<template>
  <div class="maintainers">
    <h3 class="title is-6 mb-15 mt-25">{{ $t('documents.executors') }}</h3>
    <b-autocomplete
        v-if="editable"
        class="user-search"
        type="text"
        icon="magnify"
        v-model="searchQuery"
        :data="searchResults"
        :placeholder="$t('tasks.inputNameToAddUser')"
        field="title"
        :loading="loading"
        @input="search"
        @select="add">
      <template slot-scope="props">
        <div class="media">
          <div class="media-left">
            <img class="user-image" width="42" :src="userThumb(props.option.thumb)">
          </div>
          <div class="media-content">
            {{ props.option.last_name }}
            {{ props.option.name }}
            <br>
            <small v-html="$t('tasks.position', {
                      position: props.option.position__name,
                      department: props.option.department__name
                    })">
            </small>
          </div>
        </div>
      </template>
    </b-autocomplete>
    <b-table :data="data" class="maintainers-table">
      <template slot-scope="props">
        <b-table-column :label="$t('tasks.name')" field="name" sortable>
          <a @click.prevent="detail(props.row.employee.id)">{{ props.row.employee.initials }}</a>
        </b-table-column>
        <b-table-column :label="$t('tasks.state')" field="is_read" width="160" sortable :visible="showState">
          {{ props.row.is_read ? $t('tasks.viewed') : $t('tasks.notViewed') }}
        </b-table-column>
        <b-table-column :label="$t('tasks.actions')" width="120">
          <a @click.prevent="remove(props.row.id)" v-if="props.row.can_delete || canDeleteAny">
            <b-icon icon="trash-can-outline" size="is-small"></b-icon> {{ $t('interface.remove') }}
          </a>
        </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content is-fluid has-text-grey has-text-centered">
            <p>
              <span class="has-text-grey-light">{{ $t('tasks.executorsAddTip') }}</span>
            </p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {debounce} from '@/utils'
  import defaultUserThumb from '../assets/user.svg'

  export default {
    props: {
      employees: Array,
      editable: Boolean,
      canDeleteAny: Boolean,
      scopeAll: {
        type: Boolean,
        required: false,
        default: true
      },
      showState: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    data() {
      return {
        data: this.employees,
        searchQuery: null
      }
    },
    methods: {
      search: debounce(function() {
        this.$store.dispatch(
          'Employees/search',
          {
            q: this.searchQuery,
            scope: this.isWorkflowController || this.scopeAll
          }
        )
      }),
      detail(employeeId) {
        this.$emit('detail', employeeId)
      },
      remove(maintainerId) {
        this.$emit('remove', maintainerId)
      },
      add(employee) {
        this.$emit('add', employee.id)
      },
      userThumb(thumb) {
        return thumb !== null ? thumb : defaultUserThumb
      }
    },
    computed: {
      ...mapState('Employees', ['loading', 'searchResults']),
      ...mapGetters('Account', ['isWorkflowController'])
    },
    watch: {
      employees(val) {
        this.data = val
      }
    }
  }
</script>

<style lang="scss" scoped>
  .maintainers {
    .maintainers-table {
      margin-top: 10px;
      border: 1px solid #E6E8F1;

      thead {
        background: #f6f6f6;
        td, th {
          border-width: 0 0 1px;
        }
      }

      .table {
        border: 0;
      }
    }

    .user-search {
      margin-bottom: 4px;
    }

    .user-image {
      display: block;
      border-radius: 50%;
    }
  }
</style>
